// extracted by mini-css-extract-plugin
module.exports = {"policyContent":"CancellationPolicy_policyContent__zsJXN"};